import React from 'react';
import HomePage from './home';

export default function render(entry, pageTree, featureFlags) {
    return <HomePage entry={entry} featureFlags={featureFlags} />;
}
